var map = {
	"./ACOS.svg": 81012,
	"./Add.svg": 80903,
	"./Admin.svg": 48871,
	"./Ads.svg": 91160,
	"./Amazon.svg": 68594,
	"./Analytics.svg": 70562,
	"./Arrow_Down.svg": 49136,
	"./Arrow_Left.svg": 7327,
	"./Arrow_Right.svg": 2426,
	"./Arrow_Up.svg": 64995,
	"./Automated systems.svg": 26794,
	"./Automated.svg": 32536,
	"./CPC.svg": 56750,
	"./CPM.svg": 82296,
	"./Category.svg": 27202,
	"./Centralized data.svg": 48689,
	"./Clicks.svg": 58085,
	"./Conversion Rate.svg": 30312,
	"./Cost.svg": 61821,
	"./Customized.svg": 60073,
	"./Dashboard.svg": 62314,
	"./Data.svg": 40682,
	"./Date.svg": 82998,
	"./Download.svg": 40114,
	"./Error free.svg": 57490,
	"./Facebook.svg": 19262,
	"./Filter.svg": 61928,
	"./Flipkart.svg": 97917,
	"./Gen AI.svg": 61406,
	"./Google Ads.svg": 86505,
	"./Google Analytics.svg": 44023,
	"./History.svg": 66178,
	"./Important Bulletin.svg": 57561,
	"./Impressions.svg": 40408,
	"./Inhouse ecosystem.svg": 24665,
	"./Instagram.svg": 33898,
	"./Key Metrics.svg": 77344,
	"./Keyword Tracker.svg": 54795,
	"./LQS Analyser.svg": 48201,
	"./Location.svg": 90111,
	"./Logout.svg": 96232,
	"./Mapping.svg": 52672,
	"./Market.svg": 79402,
	"./MetaIcon.svg": 83336,
	"./Minus.svg": 36358,
	"./Myntra.svg": 47225,
	"./Orders.svg": 11453,
	"./Overall spends.svg": 7528,
	"./Password.svg": 74321,
	"./Plus.svg": 31086,
	"./Price.svg": 68685,
	"./Profile Dropdown.svg": 52140,
	"./ROI.svg": 5816,
	"./Remove.svg": 76550,
	"./Reports (copy).svg": 83741,
	"./Reports.svg": 44343,
	"./Revenue.svg": 52330,
	"./SOV Report.svg": 55244,
	"./Search.svg": 97850,
	"./Sentiments.svg": 26232,
	"./Shopify.svg": 95124,
	"./Sidebar Toggle Left.svg": 86933,
	"./Sidebar Toggle Right.svg": 4920,
	"./Snapchat.svg": 33108,
	"./Sort.svg": 31162,
	"./Submit.svg": 48378,
	"./Summary.svg": 8806,
	"./SummaryIcon.svg": 46325,
	"./Tools.svg": 94683,
	"./Tooltip.svg": 61807,
	"./UpArrow.svg": 43032,
	"./User.svg": 15451,
	"./Visual analysis.svg": 22484,
	"./W_green.svg": 55173,
	"./activeGraph.svg": 53612,
	"./activeTable.svg": 17868,
	"./addPrompt.svg": 8801,
	"./amazon-ads.svg": 54951,
	"./amazon-black.svg": 23296,
	"./changebtn.svg": 51210,
	"./client.svg": 70823,
	"./close.svg": 81046,
	"./copy.svg": 1281,
	"./delete-icon.svg": 52135,
	"./dislike.svg": 34803,
	"./disliked.svg": 33205,
	"./editbtn.svg": 56962,
	"./ellipsis.svg": 82891,
	"./file-image-svgrepo-com.svg": 67813,
	"./inActiveGraph.svg": 25643,
	"./like.svg": 41567,
	"./liked.svg": 12625,
	"./meta.svg": 98257,
	"./pin-fill.svg": 1379,
	"./pin-regular.svg": 86884,
	"./refresh.svg": 77295,
	"./report-news-svgrepo-com.svg": 51601,
	"./resize_big.svg": 20045,
	"./resize_small.svg": 96946,
	"./success_loader.svg": 39623,
	"./update-icon.svg": 72553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34444;